import { useAgTechAuthContext } from '@agtech/core/auth/AgTechAuthContext';
import React, { useState } from 'react'
import { AgTechButton } from '../../../Buttons/AgTechButtons';
import { AgTechWebApplication } from '../../../../application/AgTechWebApplication';
import AgTechWebAppBackdrop from '../../Loading/AgTechWebAppBackdrop';

const AgTechWebAppLoginPage = (props: { app: AgTechWebApplication }) => {
    const authContext = useAgTechAuthContext();
    const supportsRegistration = authContext.config.supportsRegistration ?? true;

    const [isLoggingIn, setIsLoggingIn] = useState(false);

    return (
        <AgTechWebAppBackdrop app={props.app}>
            <div className='row-based h-[120px] flex'>
                {isLoggingIn ? (
                    <div className='row-based fading-in centered container'>
                        <div
                            style={{ height: 24, width: 24 }}
                            className={`text-white border-[3px] border-white border-b-transparent border-r-transparent animate-spin rounded-full`}
                        />
                    </div>
                ) : (
                    <div className='row-based fading-in centered container'>
                        <AgTechButton
                            text="Login"
                            action={() => {
                                setIsLoggingIn(true);
                                authContext.loginUser();
                            }}
                            classes='button-highlight font-semibold text-md py-3 px-5 w-[220px] justify-center rounded-md mb-5'
                        />
                        {supportsRegistration && (
                            <AgTechButton
                                text="Register"
                                action={authContext.loginUser}
                                classes='border-white font-semibold text-md py-3 px-5 w-[220px] justify-center rounded-md mb-5'
                            />
                        )}
                    </div>
                )}
            </div>
        </AgTechWebAppBackdrop>
    )
}

export default AgTechWebAppLoginPage